import React from 'react';

// 11-segment motorsport rev-strip.
// Color zones: 1-3 green, 4-6 yellow, 7-8 red, 9-11 purple.
// Segments light left-to-right based on rpmPct (0-100).
// Purple segments flash when shiftFlash is true (near redline).
const SEGMENT_COLORS = [
  '#2ecc71', '#2ecc71', '#2ecc71',
  '#f1c40f', '#f1c40f', '#f1c40f',
  '#e74c3c', '#e74c3c', '#e74c3c',
  '#9b59b6', '#9b59b6',
];

export default function RevStrip({ rpmPct, shiftFlash = false, size = 'lg' }) {
  const pct = rpmPct != null ? Math.max(0, Math.min(100, rpmPct)) : 0;
  const segH = size === 'lg' ? 'h-2.5' : 'h-1';
  const gap = size === 'lg' ? 'gap-1' : 'gap-0.5';

  return (
    <div className={`flex w-full ${gap}`}>
      {SEGMENT_COLORS.map((color, i) => {
        const threshold = (i / 11) * 100;
        const lit = pct > threshold;
        const isPurple = i >= 9;
        return (
          <div
            key={i}
            className={`flex-1 ${segH} telemetry-gauge ${lit && isPurple && shiftFlash ? 'animate-rev-flash' : ''}`}
            style={{
              background: lit ? color : 'rgba(255,255,255,0.05)',
              boxShadow: lit && size === 'lg' ? `0 0 5px ${color}AA` : 'none',
            }}
          />
        );
      })}
    </div>
  );
}